import React from 'react'
import Grid from '@mui/material/Grid'
import { TextField } from '@mui/material'
import moment from 'moment'

const formatCadNumber = (value) => {
  const rawValue = String(value || '')
  const digits = rawValue.replace(/\D/g, '').slice(0, 10)

  if (!digits) return ''

  const fallbackDate = moment().format('DDMMYY')
  const datePart = digits.slice(0, 6) || fallbackDate
  const sequencePart = digits.slice(6)

  return `${datePart}-${sequencePart}`
}

const IncidentNumber = ({ formValues, handleChange, cadLookupState }) => {
  const helperText =
    cadLookupState === 'loading'
      ? 'Checking CAD...'
      : cadLookupState === 'notFound'
        ? 'No matching CAD incident found'
        : cadLookupState === 'error'
          ? 'Unable to check CAD right now'
          : 'CAD format: DDMMYY-0001'

  return (
    <Grid item xs={12} md={6} lg={3}>
      <TextField
        label="Incident Number"
        value={formValues?.incident?.incidentNumber ?? moment().format('DDMMYY-')}
        onChange={(e) =>
          handleChange({
            moduleName: 'incident',
            field: 'incidentNumber',
            value: formatCadNumber(e.target.value),
          })
        }
        helperText={helperText}
        fullWidth
      />
    </Grid>
  )
}

export default IncidentNumber
